import { Component, OnInit } from '@angular/core';
import { FormGroup, FormBuilder } from '@angular/forms';
import { Router, ActivatedRoute } from '@angular/router';
import { Program } from 'src/app/shared/models/program';
import { ProgramService } from 'src/app/shared/service/ManageDelivery/program.service';
import { RegistedBranchService } from 'src/app/shared/service/ManageDelivery/registed-branch.service';
import { AlertyfyService } from 'src/app/shared/service/alertyfy.service';
import { SpinnerManagerService } from 'src/app/shared/service/spinnerManager.service';

@Component({
  selector: 'app-upsert-registed-branch',
  templateUrl: './upsert-registed-branch.component.html',
  styleUrls: ['./upsert-registed-branch.component.scss']
})
export class UpsertRegistedBranchComponent implements OnInit {

  btnSave = 'Save';
  Form: FormGroup;
  programid: number = 0;

  constructor(    private fb: FormBuilder,
    private router: Router,
    private route: ActivatedRoute,
    private _Service: RegistedBranchService,
    private spinningManager: SpinnerManagerService,
    private alertify: AlertyfyService) {
    this.Form = this.fb.group({
      id: '',
      name: '',
      description: '',
    });

    this.programid =
      this.route.snapshot.params.id === undefined
        ? 0
        : parseInt(this.route.snapshot.params.id);

        if (this.programid > 0) {
          this.editProgram();
        }
        this.spinningManager.hideSpinner();
   }

  ngOnInit(): void {
  }

editProgram() {
  this._Service.getById(this.programid).subscribe((result) => {
    this.spinningManager.showSpinner("Loading.....");
    this.Form = this.fb.group({
      name: result["name"],
      description: result["description"],
    });
    this.btnSave = 'Update';
  }, (error) => {
    this.alertify.error(error.error);
    this.router.navigateByUrl('/managedelevery/registed-branch-list');
  })
  this.spinningManager.hideSpinner();
}

saveProgramList() {
  if (this.programid && this.programid > 0) {
    const dataupdate = {
      id: this.programid, name: this.Form.controls.name.value,
      description: this.Form.controls.description.value,
    };
    this._Service.update(dataupdate).subscribe(result => {
      this.spinningManager.showSpinner("Saving.....");
      this.router.navigateByUrl('/managedelevery/registed-branch-list');
      this.spinningManager.hideSpinner();
    }, error => {
      this.spinningManager.hideSpinner();
    })
  } else {
    var _program = new Program();
    var program = this.Form.value;
    _program.id = Number(program.id) || 0;
    _program.name = program.name;
    _program.description = program.description;

    this._Service.create(_program)
      .subscribe(res => {
        if (res) {
          this.Form.reset();
          this.router.navigateByUrl('/managedelevery/registed-branch-list');
          this.spinningManager.hideSpinner();
        }
      }, error => {
        this.alertify.error(error);
        this.spinningManager.hideSpinner();
      }
      );
  }
  error => {
    this.spinningManager.hideSpinner();
    this.router.navigateByUrl('/managedelevery/registed-branch-list');
  }

}

}
